<script lang="ts">
	//Config
	import { mapbox_map_config } from '../../../helpers/geolocalion_helper';
	import SearchAddressFieldBox from './SearchAddressFieldBox.svelte';
	//Components
	import SelectDataList from './SelectDataList.svelte';
	import SelectOption from './SelectOption.svelte';
	// Design system components
	import { Icon, Text } from '@Shelly/shelly-design-system';

	export let countryCode: string, address: string, addressError: string;

	let geocoderIsLoaded = false,
		searchFieldBox: SearchAddressFieldBox,
		results = [];

	const onLoadMapboxGeocoder = async () => {
		geocoderIsLoaded = true;
	};

	const getResult = async (e) => {
		const search = e.detail.trim().toLowerCase();

		if (!search) {
			address = '';
			results = [];
			return;
		}
		const geocoderURL = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURI(
				search,
			)}.json?country=${countryCode}&types=address&access_token=${mapbox_map_config.apiKey}`,
			req = await fetch(geocoderURL);
		if (!req.ok) return;
		const res = await req.json();

		results = [];
		const len = res.features.length;
		for (let i = 0; i < len; ++i) {
			const data = res.features[i];
			results = [
				...results,
				{
					lat: data.center[1],
					lon: data.center[0],
					placeName: data.place_name,
					search,
				},
			];
		}
	};

	function onSelectClickHandler(result) {
		address = result.placeName;
		results = [];
		searchFieldBox.close(address);
	}

	$: if (!address) {
		searchFieldBox?.reset();
	}
</script>

{#if geocoderIsLoaded}
	<SearchAddressFieldBox on:input={getResult} bind:this={searchFieldBox} bind:addressError>
		<SelectDataList open={results.length} showItems={0}>
			{#each results as result, i}
				<SelectOption on:click={() => onSelectClickHandler(result)}>
					<div class="icon">
						<Icon size="xs" icon="fas fa-location-dot" />
					</div>
					<Text styleType="body-small" class="label">{result.placeName}</Text>
				</SelectOption>
			{/each}
		</SelectDataList>
	</SearchAddressFieldBox>
{/if}

<svelte:head>
	<link
		rel="stylesheet"
		href="https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v5.0.0/mapbox-gl-geocoder.css"
		type="text/css"
	/>
	<script
		src="https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v5.0.0/mapbox-gl-geocoder.min.js"
		on:load={onLoadMapboxGeocoder}
	></script>
</svelte:head>

<style>
	.icon {
		height: 16px;
		padding-right: 8px;
	}
</style>
